import { render } from "./ScanItem.vue?vue&type=template&id=589e527c&scoped=true"
import script from "./ScanItem.vue?vue&type=script&lang=js"
export * from "./ScanItem.vue?vue&type=script&lang=js"

import "./ScanItem.vue?vue&type=style&index=0&id=589e527c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-589e527c"]])

export default __exports__